/**
 * Default outline numbering configuration for agenda templates
 */
export const DEFAULT_OUTLINE_NUMBERING = {
    levels: {
        '1': { format: '{n}', style: '1,2,3' },
        '2': { format: '{n}', style: 'a,b,c', includeFrom: 'level_1_onwards' },
        '3': { format: '{n}', style: 'i,ii,iii', includeFrom: 'level_2_onwards' },
        '4': { format: '{n}', style: '1,2,3', includeFrom: 'level_3_onwards' },
    },
    itemNumbering: 'per_section',
    autoRenumber: false,
};
